import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
const _excluded = ["id", "style", "rotation", "mapInstance", "version", "mapSize", "interactive"];
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * MapboxService
 */

import { Map, MercatorCoordinate } from '@antv/l7-map';
import { mat4, vec3 } from 'gl-matrix';
import Viewport from "../lib/web-mercator-viewport";
import { MapType } from "../types";
import BaseMapService from "../utils/BaseMapService";

// TODO: 基于抽象类 BaseMap 实现
export default class DefaultMapService extends BaseMapService {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "version", MapType.DEFAULT);
    _defineProperty(this, "viewport", void 0);
  }
  /**
   * 将经纬度转成墨卡托坐标
   * @param lnglat
   * @returns
   */
  lngLatToCoord(lnglat, origin = {
    x: 0,
    y: 0,
    z: 0
  }) {
    // @ts-ignore
    const {
      x,
      y
    } = this.lngLatToMercator(lnglat, 0);
    return [x - origin.x, y - origin.y];
  }
  lngLatToMercator(lnglat, altitude) {
    const {
      x = 0,
      y = 0,
      z = 0
    } = MercatorCoordinate.fromLngLat(lnglat, altitude);
    return {
      x,
      y,
      z
    };
  }
  getModelMatrix(lnglat, altitude, rotate, scale = [1, 1, 1], origin = {
    x: 0,
    y: 0,
    z: 0
  }) {
    const modelAsMercatorCoordinate = MercatorCoordinate.fromLngLat(lnglat, altitude);
    // @ts-ignore
    const meters = modelAsMercatorCoordinate.meterInMercatorCoordinateUnits();
    const modelMatrix = mat4.create();
    mat4.translate(modelMatrix, modelMatrix, vec3.fromValues(modelAsMercatorCoordinate.x - origin.x, modelAsMercatorCoordinate.y - origin.y, modelAsMercatorCoordinate.z || 0 - origin.z));
    mat4.scale(modelMatrix, modelMatrix, vec3.fromValues(meters * scale[0], -meters * scale[1], meters * scale[2]));
    mat4.rotateX(modelMatrix, modelMatrix, rotate[0]);
    mat4.rotateY(modelMatrix, modelMatrix, rotate[1]);
    mat4.rotateZ(modelMatrix, modelMatrix, rotate[2]);
    return modelMatrix;
  }
  init() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const _this$config = _this.config,
        {
          id = 'map',
          style = 'light',
          rotation = 0,
          mapInstance,
          version = 'DEFAULTMAP',
          mapSize = 10000,
          interactive = true
        } = _this$config,
        rest = _objectWithoutProperties(_this$config, _excluded);
      _this.viewport = new Viewport();
      _this.version = version;
      _this.simpleMapCoord.setSize(mapSize);
      if (version === 'SIMPLE' && rest.center) {
        rest.center = _this.simpleMapCoord.unproject(rest.center);
      }
      if (mapInstance) {
        // @ts-ignore
        _this.map = mapInstance;
        _this.$mapContainer = _this.map.getContainer();
      } else {
        _this.$mapContainer = _this.creatMapContainer(id);
        _this.map = new Map(_objectSpread({
          container: _this.$mapContainer,
          bearing: rotation
        }, rest));
      }
      _this.map.on('load', () => {
        _this.handleCameraChanged();
      });
      if (interactive) {
        // L7 作为第三方地图插件时关闭重绘
        _this.map.on('move', _this.handleCameraChanged);
      }

      // 不同于高德地图，需要手动触发首次渲染
      setTimeout(() => {
        _this.handleCameraChanged();
      }, 100);
      _this.handleCameraChanged();
    })();
  }
  creatMapContainer(id) {
    let wrapper = id;
    if (typeof id === 'string') {
      wrapper = document.getElementById(id);
    }
    const container = document.createElement('div');
    container.style.cssText += `
      position: absolute;
      top: 0;
      height: 100%;
      width: 100%;
    `;
    wrapper.appendChild(container);
    return container;
  }
  exportMap(type) {
    return '';
  }
  setMapStyle(style) {}
  getCanvasOverlays() {
    return this.getContainer();
  }
}